module.exports = __webpack_public_path__ + "img/12.2dbf2b9a.jpg";